import React, { useState, useRef, useEffect } from "react";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import AssetsPack from "../../../util/AssetsPack";
import styles from "./QuestionComponent.module.css";
import ImageComponent from "../../../components/ImageComponent";

interface QuestionComponentProps {
  question: string;
  answer: string;
}

const QuestionComponent: React.FC<QuestionComponentProps> = ({
  question,
  answer,
}) => {
  const [isCardExpanded, setExpandedCard] = useState(false);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [ques, setQuestion] = useState(question);

  useEffect(() => {
    setQuestion(question);
    setExpandedCard(false);
    if (contentRef.current) {
      contentRef.current.style.height = "0";
    }
  }, [ques, answer]);

  const onExpandCollapseCard = () => {
    const element = contentRef.current;

    if (element) {
      if (!isCardExpanded) {
        element.style.height = `${element.scrollHeight}px`;
        setTimeout(() => {
          if (element) {
            element.style.height = "auto";
          }
        }, 300);
      } else {
        element.style.height = `${element.scrollHeight}px`;
        requestAnimationFrame(() => {
          if (element) {
            element.style.height = "0";
          }
        });
      }
    }

    setExpandedCard(!isCardExpanded);
  };

  return (
    <div className={styles["question-main-container"]}>
      <div
        className={styles["question-container"]}
        onClick={onExpandCollapseCard}
      >
        <Paragraph
          size={ParagraphSize.paragraph2}
          classNameStyle={styles["description-text"]}
        >
          {ques}
        </Paragraph>
        <ImageComponent
          src={
            !isCardExpanded
              ? AssetsPack.icons.ADD.default
              : AssetsPack.icons.ICON_CROSS.default
          }
          alt="Toggle Icon"
        />
      </div>

      <div
        ref={contentRef}
        className={`${styles["expanded-content"]} ${
          isCardExpanded ? styles["show"] : ""
        }`}
      >
        <Paragraph
          size={ParagraphSize.paragraph2}
          classNameStyle={styles["remove-margin"]}
        >
          {answer}
        </Paragraph>
      </div>
    </div>
  );
};

export default QuestionComponent;
